import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import axiosInstance from '../../axiosConfig';

const fetchUsers = async (params) => {
  const { data } = await axiosInstance.get('/promethee_admin/users/', {
    params,
  });
  return data;
};

export const useGetUsers = (params = {}, options = {}) => {
  const queryParams = useMemo(() => {
    const out = {};
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') out[k] = v;
    });
    return out;
  }, [params]);

  const query = useQuery({
    queryKey: ['admin', 'users', queryParams],
    queryFn: () => fetchUsers(queryParams),
    enabled: options.enabled ?? true,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });

  return {
    users: query.data?.results ?? [],
    count: query.data?.count ?? 0,
    ...query,
  };
};
